import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { mp } from "./mixpanel";
import { selectIsLoggedIn, selectUserId, selectUserEmail } from "../../pages/utillity-pages/login/store/auth.selectors";

// Identifies the current user with Mixpanel whenever an authenticated session is
// active, not just on the login form submit - covers sessions restored from
// persisted Redux state (e.g. page refresh) where login.tsx's identify() never runs.
export function useIdentifyUser() {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const userId = useSelector(selectUserId);
  const userEmail = useSelector(selectUserEmail);
  const identifiedUserId = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoggedIn || !userId || identifiedUserId.current === userId) {
      return;
    }
    identifiedUserId.current = userId;
    mp.identify(userId);
    if (userEmail) {
      mp.peopleSet({ $email: userEmail });
    }
  }, [isLoggedIn, userId, userEmail]);
}
